import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { string, object } from 'yup';
import { Form, ActionsWrapper } from '@contently/toolkit';
import GrapeFormat from '../../utils/formatters/formik-grape-formatter';
import { post } from '../../../utils/shared/api';
import { handleSubmitError } from '../../utils/errors';

const CommentForm = props => {
  const { handleSubmit, handleBlur, handleChange, values, errors, touched, isSubmitting } = props;

  return (
    <form onSubmit={handleSubmit} data-parsley-excluded="true">
      <Form.ErrorWrapper touched={touched.body} error={errors.body}>
        <Form.MarkdownPreviewTextarea
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.body}
          name="body"
          id="body"
          placeholder="Your comment"
          resize={false}
          outdated
        />
      </Form.ErrorWrapper>

      <ActionsWrapper standalone>
        <Form.ButtonWithProgress
          type="submit"
          disabled={isSubmitting}
          variant="secondary"
          size="small"
        >
          Comment
        </Form.ButtonWithProgress>
      </ActionsWrapper>
    </form>
  );
};

CommentForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  errors: PropTypes.instanceOf(Object).isRequired,
  touched: PropTypes.instanceOf(Object).isRequired,
  values: PropTypes.instanceOf(Object).isRequired
};

const NewCommentForm = props => {
  const { addComment, path } = props;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const defaultValues = { body: '' };

  return (
    <Formik
      enableReinitialize
      initialValues={{ ...defaultValues }}
      validationSchema={object().shape({
        body: string().required('Comment body is required')
      })}
      onSubmit={(formValues, actions) => {
        const { resetForm } = actions;

        setIsSubmitting(true);

        post(path, JSON.stringify(GrapeFormat({ ...formValues })), true)
          .then(comment => {
            setIsSubmitting(false);
            addComment(comment);
            resetForm({ body: '' });
          })
          .catch(errorResponse => {
            handleSubmitError(errorResponse, actions, 'There was an error saving your comment.');

            setIsSubmitting(false);
          });
      }}
      render={innerProps => <CommentForm {...innerProps} isSubmitting={isSubmitting} />}
    />
  );
};

NewCommentForm.propTypes = {
  addComment: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired
};

export default NewCommentForm;



// WEBPACK FOOTER //
// ./app/javascript/app/components/comments/comment_form.jsx